import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function LoadMoreButton({ handler, className }) {
  return (
    <div className={classNames('content-info-cell -btns', className)}>
      <span className="btn -secondary" onClick={handler}>
        Загрузить еще
      </span>
    </div>
  );
}

LoadMoreButton.propTypes = {
  handler: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default LoadMoreButton;
